<template>
  <div id="smartcam" class="container">
    <PageLoader v-if="loading"/>
    <div class="warning" v-if="smartCamDataGrafica.length === 0 && !loading">
      <br /><br />
      <div class="text">
        <h1>Sem dados de camera, contatar ao suporte de Pecsmart</h1>
      </div>
    </div>

    <div v-if="smartCamDataGrafica.length > 0 && !loading">
      <LastDate :date="lastPing"/>
      <div style="display: flex; gap: 16px; margin-bottom: 24px; flex-wrap: wrap;">
        <div class="info-card"  style="cursor:pointer;">
          <p>Andamento</p>
          <span class="green-text">{{last_batch_weight && last_batch_weight.datetime_fetched ? dateCompare(batch.date_accomodation, last_batch_weight.datetime_fetched) : 0}} dias</span>
        </div>
        <div class="info-card" @click="showGraph('losses')" :class="selectedChart === 'losses' ? 'borderActive' : ''" style="cursor:pointer;">
          <p>Animais</p>
          <span class="valor-estimado-camv3" style="color: #6B6C6C;" title="Quantidade total de animais">{{batch.initial_count}}</span> •
          <span title="Quantidade de animais vivos" class="green-text">{{batch.initial_count - lossesTotal}}</span>
        </div>
        <div class="info-card highlight" :style="cardStyleBackground" @click="showGraph('weight')" :class="selectedChart === 'weight' ? 'borderActive' : ''" style="cursor:pointer;">
          <p class="white-text">Peso em kg</p>
          <span id="weight_estimado" class="valor-estimado-camv3">{{cardExpectedWeight && cardExpectedWeight.y ? cardExpectedWeight.y.toFixed(2) : '0.00'}}</span> •
          <span id="weight" class="white-text">{{last_batch_weight && last_batch_weight.weight ? last_batch_weight.weight.toFixed(2) : '0.00'}}</span>
        </div>
        <div class="info-card" @click="showGraph('gpdAcc')" :class="selectedChart === 'gpdAcc' ? 'borderActive' : ''" style="cursor:pointer;">
          <p>GPD acumulado</p>
          <span>{{cardGPDAcc && cardGPDAcc.x !== undefined ? cardGPDAccExpected(cardGPDAcc.x).y : '0.00'}}</span> •
          <span class="valor-atual-ruim" :style="cardStyleColor(cardGPDAcc && cardGPDAcc.x !== undefined ? cardGPDAccExpected(cardGPDAcc.x).y : 0, cardGPDAcc && cardGPDAcc.y !== undefined ? cardGPDAcc.y : 0)">{{cardGPDAcc && cardGPDAcc.y !== undefined ? cardGPDAcc.y.toFixed(2) : '0.00'}}</span>
        </div>
      </div>

      <div class="clear">
        <p class="alert-success">
          Desempenho do lote dentro da média estimada. Peso alvo de abate atingido
          em: 08/03/2024.
        </p>
      </div>

      <div>
        <SmartCamChart 
          :key="componentKey + '-losses'" 
          v-if="selectedChart === 'losses'" 
          v-bind:camDates="camDates" 
          v-bind:camManualDates="camManualDates" 
          v-bind:min_x="0" 
          v-bind:max_x="max_x" 
          v-bind:sets="lossesChartSetting" 
          v-bind:label="'Animais [Unid]'" 
          v-bind:max_y="batch.initial_count" 
          v-bind:min_y="(batch.initial_count - lossesTotal * 2)"
        />
        <SmartCamChart 
          :key="componentKey + '-weight-' + minWeightHeight + '-' + maxWeightHeight" 
          v-if="selectedChart === 'weight'" 
          v-bind:camDates="camDates" 
          v-bind:camManualDates="camManualDates" 
          v-bind:min_x="min_x" 
          v-bind:max_x="max_x" 
          v-bind:sets="weightChartSetting" 
          v-bind:label="'Peso [kg]'" 
          v-bind:max_y="maxWeightHeight" 
          v-bind:min_y="minWeightHeight"
          v-bind:bridgeDepartureDay="bridgeDepartureDay"
          v-bind:dateAccommodation="batch.date_accomodation"
        />
        <SmartCamChart 
          :key="componentKey + '-gpdAcc'" 
          v-if="selectedChart === 'gpdAcc'" 
          v-bind:camDates="camDates" 
          v-bind:min_x="min_x" 
          v-bind:max_x="max_x" 
          v-bind:sets="gpdAccChartSetting" 
          v-bind:label="'GPD Acumulado [kg]'"
        />
      </div>

    </div>
  </div>
</template>

<script>
import SmartCamChart from "../components/SmartCamChart";
import PageLoader from "../components/Loader.vue"
import LastDate from '../components/LastDate.vue'
import { format, parseISO } from 'date-fns'

export default {
  name: "SmartCamV3",
  components: {
    SmartCamChart,
    PageLoader,
    LastDate,
  },
  props: {
    curveWeightReference: {
      type: Array,
      default: () => []
    },
    userLevel: {
      type: String,
      default: ''
    },
    camV3Data: {
      type: Array,
      default: () => []
    },
    batchData: {
      type: Object,
      default: () => ({})
    },
    lossesData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      componentKey: 0,
      loading: false,
      selectedChart: 'weight', // default
    }
  },
  methods: {
    gpdWeek(accomodation) {
      return this.smartCamDataGrafica.map((item, index) => {
        if (index === 0) {
          return {
            "x": this.dateCompare(item.datetime_fetched, accomodation),
            "y": 1
          }
        }
        if (index < 7) {
          return {
            "x": this.dateCompare(item.datetime_fetched, accomodation),
            "y": Number(((item.weight - this.smartCamDataGrafica[0].weight)/index).toFixed(4))
          }
        }
        else {
          return {
            "x": this.dateCompare(item.datetime_fetched, accomodation),
            "y": Number(((item.weight - this.smartCamDataGrafica[index - 6].weight)/6).toFixed(4))
          }
        }
      })
    },
    gpdWeekExpected() {
      return this.curveWeightReference.map((item, index) => {
        if (index === 0) {
          return {
            "x": item.age,
            "y": 1
          }
        }
        if (index < 7) {
          return {
            "x": item.age,
            "y": Number(((item.weight - this.curveWeightReference[0].weight)/index).toFixed(4))
          }
        }
        else {
          return {
            "x": item.age,
            "y": Number(((item.weight - this.curveWeightReference[index - 6].weight)/6).toFixed(4))
          }
        }
      })
    },
    cardGPDWeekExpected(final_age) {
      const gpd_list = this.gpdWeekExpected()
      const gpd_expected = gpd_list.find(item => {
        if (item !== null) {
          return item.x === final_age
        }
      })
      if (gpd_expected === undefined) {
        return {"x": 0, "y": 0}
      }
      else {
        return gpd_expected
      }
    },
    gpdAcc(accomodation) {
      return this.smartCamDataGrafica.map(item => {
        const day = this.dateCompare(item.datetime_fetched, accomodation);
        if (day < 1) {
          return null;
        } else {
          return {
            "x": day,
            "y": Number(((item.weight - this.batch.average_initial_weight)/(day)).toFixed(4))
          }
        }
      })
    },
    gpdAccExpected() {
      if (!this.smartCamDataGrafica.length || !this.curveWeightReference.length) {
        return [];
      }

      const firstRedWeight = this.smartCamDataGrafica[0].weight;
      const { closestIndex, initialAge, initialWeight } = this.getCurveAlignmentIndexAndOffset(this.curveWeightReference, firstRedWeight);

      return this.curveWeightReference
        .filter((item, idx) => idx >= closestIndex)
        .map(item => {
          const ageDiff = item.age - initialAge;
          if (ageDiff < 1) {
            return null;
          } else {
            return {
              x: ageDiff,
              y: Number(((item.weight - initialWeight) / ageDiff).toFixed(4))
            };
          }
        })
        .filter(item => item !== null);
    },
    cardGPDAccExpected(final_age) {
      const gpd_list = this.gpdAccExpected()
      const gpd_expected = gpd_list.find(item => {
        if (item !== null) {
          return item.x === final_age
        }
      })
      if (gpd_expected === undefined) {
        return {"x": 0, "y": 0}
      }
      else {
        return gpd_expected
      }
    },
    forceRerender: function() {
      this.componentKey += 1
    },
    dateCompare: function(first_date, second_date) {
      return Math.ceil(Math.abs(new Date(second_date) - new Date(first_date)) / (1000 * 60 * 60 * 24));
    },
    camWeights: function(accomodation) {
      return this.smartCamDataGrafica.map(item => {
        return {
          "x": this.dateCompare(item.datetime_fetched, accomodation),
          "y": item.weight,
          "datetime_fetched": item.datetime_fetched
        }
      })
    },
    manualWeights: function() {
      return []
    },
    standardDeviation: function(accomodation) {
      return this.smartCamDataGrafica.map(item => {
        return {
          "x": this.dateCompare(item.datetime_fetched, accomodation),
          "y": item.standard_deviation
        }
      })
    },
    uniformity: function(accomodation) {
      return this.smartCamDataGrafica.map(item => {
        return {
          "x": this.dateCompare(item.datetime_fetched, accomodation),
          "y": Number((100*item.uniformity).toFixed(4))
        }
      })
    },
    cardStyleColor: function(expected, real) {
      const percentage = (real * 100)/expected
      if (percentage > 105) {
        return 'color: #415430;'
      }
      if (percentage >= 100) {
        return 'color: #a1cd7b'
      }
      if (percentage >= 95) {
        return 'color: #e2bf65'
      }
      if (percentage < 95) {
        return 'color: #a94949'
      }
    },
    dataLosses: function(accomodation){
      this.forceRerender()

      if (!this.last_batch_weight || !this.last_batch_weight.datetime_fetched) {
        return []
      }

      const lossesByBatch = this.losses
      const initialNumberOfPigs = this.batch.initial_count
      const durationBatchInDays = this.dateCompare(accomodation, this.last_batch_weight.datetime_fetched)
      const pigsAliveEachDay = []

      for(let i = 0; i < durationBatchInDays + 1; i++){
        let totalDeathsTillThisDay = 0
        lossesByBatch.forEach(item => {
          if (this.dateCompare(item.death_datetime, accomodation) <= i){
            totalDeathsTillThisDay += item.quantity
          }
        })
        
        pigsAliveEachDay.push({
          x: i,
          y: initialNumberOfPigs - totalDeathsTillThisDay,
        })
      }
      return pigsAliveEachDay
    },
    showGraph: function(chart) {
      this.selectedChart = chart;
      this.forceRerender();
    },
    findBridgePoint(allWeights) {
      const bridgeDay = this.bridgeDepartureDay;
      if (bridgeDay == null) return null;

      const exactPoint = allWeights.find(p => p.x === bridgeDay);
      if (exactPoint) return { ...exactPoint };

      const bridgeDateStr = String(this.bridgeDepartureDate).split('T')[0];
      const dateMatch = allWeights.find(p => String(p.datetime_fetched || '').split('T')[0] === bridgeDateStr);
      if (dateMatch) return { ...dateMatch, x: bridgeDay };

      const before = [...allWeights].filter(p => p.x < bridgeDay).pop();
      const after = allWeights.find(p => p.x > bridgeDay);
      if (before && after) {
        const ratio = (bridgeDay - before.x) / (after.x - before.x);
        return {
          x: bridgeDay,
          y: before.y + ratio * (after.y - before.y),
          datetime_fetched: this.bridgeDepartureDate,
        };
      }
      if (before) {
        return { x: bridgeDay, y: before.y, datetime_fetched: this.bridgeDepartureDate };
      }

      return null;
    },
    getCurveAlignmentIndexAndOffset(curve, firstWeight) {
      let minDiff = Infinity;
      let closestIndex = 0;
      curve.forEach((item, idx) => {
        const diff = Math.abs(item.weight - firstWeight);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = idx;
        }
      });
      return {
        closestIndex,
        initialAge: curve[closestIndex].age,
        initialWeight: curve[closestIndex].weight
      };
    },
  },
  computed: {
    batch() {
      return this.batchData && Object.keys(this.batchData).length > 0 ? this.batchData : {
        pk: 1,
        initial_count: 150,
        date_accomodation: "2024-01-14T00:00:00.000Z",
        date_departure: null,
        average_initial_weight: 25.0,
        manual_weight: []
      }
    },
    selectSensorCam() {
      if (!this.batch || !this.batch.pk || !this.$store.getters.getSensorsListCam) {
        return null
      }
      return this.$store.getters.getSensorsListCam.find(obj => obj.batch && obj.batch.pk == this.batch.pk)
    },
    lastPing() {
      const lastPing = this.selectSensorCam?.data[0]?.datetime_last_ping
      if (!lastPing) return "--"
      return format(parseISO(lastPing), 'dd-MM-yyyy hh:mm' )
    },
    camDates: function() {
      return this.smartCamDataGrafica.map(item => item.datetime_fetched)
    },
    camManualDates: function() {
      return []
    },
    cardGPDAcc() {
      const gpd_list = this.gpdAcc(this.batch.date_accomodation)
      const gpd_acc = gpd_list[gpd_list.length - 1]
      if (gpd_acc === null) {
        return {"x": 0, "y": 0}
      }
      else {
        return gpd_acc
      }
    },
    cardGPDWeek() {
      const gpd_list = this.gpdWeek(this.batch.date_accomodation)
      return gpd_list[gpd_list.length - 1]
    },
    cardExpectedWeight() {
      if (!this.last_batch_weight || !this.last_batch_weight.datetime_fetched) {
        return {x: 0, y: 0}
      }
      const expected_weight = this.expectedWeight.find(item => item.x  === this.dateCompare(this.last_batch_weight.datetime_fetched, this.batch.date_accomodation))
      if (expected_weight === undefined) {
        return {x: 0, y: 0}
      }
      else {
        return expected_weight
      }
    },
    min_x() {
      return 0
    },
    max_x() {
      if (!this.last_batch_weight || !this.last_batch_weight.datetime_fetched) {
        return 0
      }
      return this.dateCompare(this.last_batch_weight.datetime_fetched, this.batch.date_accomodation)
    },
    expectedWeight() {
      if (!this.smartCamDataGrafica.length || !this.curveWeightReference.length) {
        return this.curveWeightReference.map(item => ({ x: item.age, y: item.weight }));
      }

      const firstCam = this.smartCamDataGrafica[0];
      const d0 = this.dateCompare(firstCam.datetime_fetched, this.batch.date_accomodation);
      const { initialAge } = this.getCurveAlignmentIndexAndOffset(this.curveWeightReference, firstCam.weight);
      const lastDay = this.max_x;

      return this.curveWeightReference
        .map(item => ({
          x: item.age - initialAge + d0,
          y: item.weight
        }))
        .filter(item => item.x >= 0 && item.x <= lastDay);
    },
    lossesChart(){
      return true
    },
    weightChartSetting() {
      const accomodation = this.batch.date_accomodation;
      const allWeights = this.camWeights(accomodation);
      const bridgeDay = this.bridgeDepartureDay;
      const bridgePoint = this.findBridgePoint(allWeights);

      const preBridge = bridgeDay != null
        ? allWeights.filter(p => p.x < bridgeDay)
        : allWeights;
      const postBridge = bridgeDay != null
        ? allWeights.filter(p => p.x > bridgeDay)
        : [];

      if (bridgePoint && !preBridge.some(p => p.x === bridgeDay)) {
        preBridge.push({ ...bridgePoint });
      }
      if (bridgePoint && postBridge.length && !postBridge.some(p => p.x === bridgeDay)) {
        postBridge.unshift({ ...bridgePoint });
      }

      const bridgeIndex = bridgeDay != null
        ? preBridge.findIndex(p => p.x === bridgeDay)
        : -1;

      const buildPointStyles = (length, highlightIndex, normalValue, highlightValue) =>
        Array.from({ length }, (_, i) => (i === highlightIndex ? highlightValue : normalValue));

      const settings = [
        {
          label: "SmartCamV3",
          backgroundColor: "red",
          data: preBridge,
          pointRadius: bridgeIndex >= 0
            ? buildPointStyles(preBridge.length, bridgeIndex, 3, 5)
            : 3,
          type: 'line',
          pointBackgroundColor: 'red',
          pointBorderColor: bridgeIndex >= 0
            ? buildPointStyles(preBridge.length, bridgeIndex, 'red', '#ffffff')
            : 'red',
          pointBorderWidth: bridgeIndex >= 0
            ? buildPointStyles(preBridge.length, bridgeIndex, 1, 2)
            : 1,
          borderColor: 'red',
          borderWidth: 2,
          lineTension: 0.6,
          fill: false,
          hitRadius: bridgeIndex >= 0
            ? buildPointStyles(preBridge.length, bridgeIndex, 3, 8)
            : 3,
        },
      ];

      if (postBridge.length) {
        settings.push({
          label: "Durante despunte del lote",
          backgroundColor: "#CD5C5C",
          data: postBridge,
          pointRadius: postBridge.map((p, i) => (i === 0 && bridgeDay != null && p.x === bridgeDay ? 0 : 3)),
          type: 'line',
          pointBackgroundColor: '#CD5C5C',
          pointBorderColor: '#CD5C5C',
          borderColor: '#CD5C5C',
          borderWidth: 2,
          lineTension: 0.6,
          fill: false
        });
      }

      settings.push({
          label: "Esperado",
          backgroundColor: "#171a5c",
          data: this.expectedWeight,
          pointRadius: 2,
          type: 'line',
          pointBackgroundColor: '#171a5c',
          borderColor: '#171a5c',
          borderWidth: 2,
          lineTension: 0.6,
          fill: false
        });

      return settings 
    },
    standandDeviationChartSetting() {
      const setting = [
        {
          label: 'Desvio Padrão',
          pointRadius: 3,
          data: this.standardDeviation(this.batch.date_accomodation),
          type: 'line',
          backgroundColor: "rgba(137, 194, 91, 0.5)",
          pointBackgroundColor: '#89c25b',
          borderColor: '#89c25b',
          borderWidth: 2,
          lineTension: 0.6,
        }
      ]
      return setting
    },
    uniformityChartSetting() {
      const setting = [
        {
          label: 'Uniformidade',
          pointRadius: 3,
          data: this.uniformity(this.batch.date_accomodation),
          type: 'line',
          backgroundColor: "rgba(137, 194, 91, 0.5)",
          borderColor: '#89c25b',
          pointBackgroundColor: '#89c25b',
          borderWidth: 2,
          lineTension: 0.6,
        }
      ]
      return setting
    },
    gpdWeekChartSetting() {
      const setting = [
        {
          label: 'GPD Esperado',
          backgroundColor: "#171a5c",
          data: this.gpdWeekExpected(),
          pointRadius: 1,
          type: 'line',
          pointBackgroundColor: '#171a5c',
          borderColor: '#171a5c',
          borderWidth: 2,
          lineTension: 0.6,
          fill: false
        },
        {
          label: 'GPD Semana',
          pointRadius: 3,
          data: this.gpdWeek(this.batch.date_accomodation),
          type: 'line',
          backgroundColor: "rgba(137, 194, 91, 0.5)",
          borderColor: '#89c25b',
          pointBackgroundColor: '#89c25b',
          borderWidth: 2,
          lineTension: 0.6,
        },
      ]
      return setting
    },
    gpdAccChartSetting() {
      const setting = [
        {
          label: 'GPD Esperado',
          backgroundColor: "#171a5c",
          data: this.gpdAccExpected(),
          pointRadius: 1,
          type: 'line',
          pointBackgroundColor: '#171a5c',
          borderColor: '#171a5c',
          borderWidth: 2,
          lineTension: 0.6,
          fill: false
        },
        {
          label: 'GPD Acumulado',
          pointRadius: 3,
          data: this.gpdAcc(this.batch.date_accomodation),
          type: 'line',
          backgroundColor: "rgba(137, 194, 91, 0.5)",
          borderColor: '#89c25b',
          pointBackgroundColor: '#89c25b',
          borderWidth: 2,
          lineTension: 0.6,
        }
      ]
      return setting
    },
    lossesChartSetting () {
      const settings = [
        {
          label: 'Losses',
          pointRadius: 3,
          data: this.dataLosses(this.batch.date_accomodation),
          type: 'line',
          backgroundColor: "rgba(137, 194, 91, 0.5)",
          pointBackgroundColor: '#89c25b',
          borderColor: '#89c25b',
          borderWidth: 2,
          lineTension: 0.6,
        }
      ]
      return settings
    },
    weigthChart() {
      return true
    },
    standandDeviationChart() {
      return true
    },
    uniformityChart() {
      return true
    },
    gpdWeekChart() {
      return true
    },
    gpdAccChart() {
      return true
    },
    maxWeightHeight() {
      const maxRed = this.smartCamDataGrafica.reduce((total, next) => Math.max(total, next.weight), 0);
      const maxBlue = this.expectedWeight.reduce((total, next) => Math.max(total, next.y), 0);
      const padded = Math.max(maxRed, maxBlue) + 10;
      return Math.ceil(padded / 10) * 10;
    },
    minWeightHeight() {
      const mapped_list = this.smartCamDataGrafica.map(item => (item.weight))
      const padded = mapped_list.reduce((total, next) => Math.min(total, next)) - 5
      return Math.max(0, Math.floor(padded / 10) * 10);
    },
    smartCamDataGrafica() {
      if (this.camV3Data.length === 0) {
        return []
      }
      return this.camV3Data.map((obj)=>{
        return {
          ...obj,
          datetime_fetched: obj.date || obj.datetime_fetched,
          bridge_departure_date: obj.bridge_departure_date || null,
          weight: obj.weight || obj.weight_mean,
          standard_deviation: obj.standard_deviation || obj.weight_std,
          uniformity: obj.uniformity || (0.85 + (Math.random() * 0.1)) // uniformity fake entre 0.85-0.95
        }
      })
    },
    verifyShowData() {
      return this.last_batch_weight?.datetime_fetched ? this.dateCompare(this.batch.date_accomodation, this.last_batch_weight.datetime_fetched) > 29 : false
    },
    losses() {
      return this.lossesData && this.lossesData.length > 0 ? this.lossesData : []
    },
    lossesTotal() {
      return this.losses.reduce((sum, obj)=> sum + obj.quantity, 0)
    },
    bridgeDepartureDate() {
      const item = this.smartCamDataGrafica.find(d => d.bridge_departure_date);
      return item?.bridge_departure_date ?? null;
    },
    bridgeDepartureDay() {
      if (!this.bridgeDepartureDate || !this.batch?.date_accomodation) return null;
      return this.dateCompare(this.batch.date_accomodation, this.bridgeDepartureDate);
    },
    last_batch_weight() {
      if (!this.smartCamDataGrafica || this.smartCamDataGrafica.length === 0) {
        return null
      }
      return this.smartCamDataGrafica[(this.smartCamDataGrafica.length) - 1]
    },
    cardStyleBackground() {
      if (!this.last_batch_weight || !this.last_batch_weight.weight || !this.cardExpectedWeight || !this.cardExpectedWeight.y) {
        return 'background: #a94949;'
      }
      const percentage = (this.last_batch_weight.weight * 100)/this.cardExpectedWeight.y
      if (percentage > 105) {
        return 'background: #415430;'
      }
      if (percentage >= 100) {
        return 'background: #a1cd7b;'
      }      
      if (percentage >= 95) {
        return 'background: #e2bf65;'
      }
      return 'background: #a94949;'
    },
  },
  async created() {
    this.loading = false
  }
};
</script>

<style scoped>

#crescimento {
  max-height: 89px;
}

.warning {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.warning .text {
  background: #78b843;
  border-radius: 10px;
  color: #fff;
  padding: 20px;
  font-size: 30px;
}

.warning .text h1 {
  display: flex;
  justify-content: center;
}

.warning .text p {
  display: flex;
  justify-content: center;
  margin: 0;
}

.register-batch {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.register-batch button {
  width: 400px;
  height: 200px;
  background: #fff;
  border: 4px solid #78b843;
  border-radius: 10px;
  outline: none;
  transition: 0.2s ease-out
}

.register-batch button h1 {
  font-size: 60px;
  color: #78b843
}

.register-batch button:hover {
  background: #78b843;
}

.register-batch button:hover h1,
.register-batch button:hover p{
  color: #fff;
}

.register-batch button p {
  font-size: 30px;
  color: #78b843;
  padding: 10px;
  margin: 0;
}

.green-text {
  color: #78b843;
}

.white-text{
  color: #fff;
}

.valor-estimado-camv3{
  color: #fff;
}

#peso p {
  color: white;
}

#peso #weight {
  color: white;
}

.borderActive{
  border: 3px solid #78b843;
}

#losses:hover{
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .warning {
    height: 250px;
  }

  .warning h1 {
    font-size: 30px;
  }

  .warning p {
    font-size: 20px;
  }

  .register-batch {
    height: 220px;
  }

  .register-batch button {
    width: 250px;
    height: 150px;
    font-size: 25px;
    outline: none;
    transition: 0.2s ease-out
  }

  .register-batch button h1 {
    font-size: 32px;
  }

  .register-batch button p {
    font-size: 20px;
  }
}

@media screen and (max-width: 480px) {
  .warning h1 {
    font-size: 25px;
  }

  .warning p {
    font-size: 15px;
  }
}

@media screen and (max-width: 360px) {
  .warning {
    height: 200px;
  }

  .warning h1 {
    font-size: 20px;
  }

  .warning p {
    font-size: 12px;
  }
}

.info-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 12px 24px;
  margin: 0 12px 12px 0;
  display: inline-block;
  min-width: 160px;
  text-align: center;
  font-size: 1.1em;
}
</style>


